<template>
    <b-modal :title="$t('copy_from_quote')"
        :no-close-on-backdrop="true"
        hide-footer
        ref="innermodal"
        @shown="onShown">
        <div class="vld-parent" ref="formContainer" style="min-height: 200px;">
            <table class="table table-sm no-bor no-top-bor">
                <thead>
                    <tr>
                        <th>{{$t('quote_no')}}</th>
                        <th>{{$t('quote_date')}}</th>
                        <th>{{$t('phone')}}</th>
                        <th class="text-right">{{$t('total_amount')}}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="ret in list" :key="ret.Id">
                        <td>{{ret.Num}}</td>
                         <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                        <td>{{ret.Phone}}</td>
                        <td class="text-right">{{$money(ret.TotalAmount)}}</td>
                        <td class="text-right">
                            <a href="javascript:void(0)" @click="onCopy(ret)">{{$t('copy')}}</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </b-modal>
</template>
<script>
export default {
    props: {
        customerId: String
    },
    data(){
        return {
            query: {
                CustomerId: this.customerId
            },
            list: []
        }
    },
    methods: {
        onShown(){
            var loading = this.$loading.show({
                container: this.$refs.formContainer,
            });
            this.$api().post('sale/quotes', this.query).then(res => {
                if(this.$isValid(res)){
                    this.list = res.data.Json.Quotes;
                }
            }).finally(function() { loading.hide(); });
        },
        onCopy(item){
            this.$emit('copy', item.Id);
        }
    },
    watch: {
        customerId(value) { this.query.CustomerId = value; }
    }
}
</script>
<style scoped>
    .no-top-bor thead th{
        border-top: none !important;
    }
</style>